import httpClient from './httpClient'

const END_POINT = '/api/nivels'

const getAllNiveles = async () => await httpClient.get(END_POINT)
const getNivelesPorIdioma = async (idioma) => await httpClient.get(END_POINT, {"params": {"idioma": idioma} })

export {

    getAllNiveles,
    getNivelesPorIdioma,

}